import { render, staticRenderFns } from "./post-item.vue?vue&type=template&id=dafc88ea"
import script from "./post-item.vue?vue&type=script&lang=js"
export * from "./post-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports